"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateOptinStatus = updateOptinStatus;

var _ActionTypes = require("crm_data/actions/ActionTypes");

var _Dispatch = require("crm_data/dispatch/Dispatch");

function updateOptinStatus(optinName, optinStatus) {
  (0, _Dispatch.dispatchQueue)(_ActionTypes.UPDATE_OPTIN_STATUS, {
    optinName: optinName,
    optinStatus: optinStatus
  });
}